export const data = {
	list: [
		{
			track: 'MenuFixed_ClicouAgendeSeuTesteDrive',
			name: 'ELEGÍ LA TUYA',
			href: 'https://fiat.com.ar/contactenos?type=191',
			target: '_blank',
			dark: true,
			router: false,
		},
	],
};

export default data;
